<template>
    <section>
        <a :name="iconType" />
        <div class="notification" v-if="iconType == 'pre-icon'">
            Pre index of complexity outcome and need (ICON)
        </div>
        <div class="notification" v-if="iconType == 'post-icon'">
            Post index of complexity outcome and need (ICON)
        </div>

        <article class="message is-info" v-if="iconType == 'post-icon'">
          <div class="message-header">
            <p>Info</p>
          </div>
          <div class="message-body">
            Start by filling in post index of complexity outcome and need below. It will be used when comparing with the pre index of complexity outcome and need score you fill in afterwards in order to get the improvement grade.
          </div>
        </article>

        <div class="columns">
            <div class="column">
                <div class="field">
                  <label class="label has-text-left">Aesthetic</label>
                  <div class="field has-addons">
                      <div class="control is-expanded">
                        <div class="select is-fullwidth">
                          <select v-model="icon.aesthetic">
                            <option v-for="(aesthetic_option, aesthetic_option_index) in aesthetic_options" v-bind:value="{ id: aesthetic_option.value, text: aesthetic_option.text }" :key="'aesthetic_' + aesthetic_option_index">{{ aesthetic_option.text }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="control">
                          <button class="button is-primary" @click="showAestheticOptionsModal = true">Show aesthetic options</button>
                      </div>
                  </div>
                </div>

                <aesthetic-options :show.sync="showAestheticOptionsModal" :aesthetic_option.sync="icon.aesthetic"/>

                <div class="field">
                  <label class="label has-text-left">Upper arch crowding (mm)</label>
                  <div class="control is-expanded">
                    <div class="select is-fullwidth">
                      <select v-model="icon.upper_arch_crowding" @change="upperControl" :disabled="!['', 'N/A'].includes(this.icon.upper_spacing.id)">
                        <option v-for="(upper_arch_crowding_option, upper_arch_crowding_option_index) in upper_arch_crowding_options" v-bind:value="{ id: upper_arch_crowding_option.value, text: upper_arch_crowding_option.text }" :key="'upper_arch_crowding_' + upper_arch_crowding_option_index">{{ upper_arch_crowding_option.text }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <article  name="upper_crowding_info" class="message is-info" v-show="this.show_upper_crowding_info">
                  <div class="message-header">
                    <p>Info</p>
                    <button class="delete" aria-label="delete" @click="show_upper_crowding_info = false"></button>
                  </div>
                  <div class="message-body">
                    Upper spacing can't occur at the same time as crowding
                  </div>
                </article>

                <div class="field">
                  <label class="label has-text-left">Upper spacing (mm)</label>
                  <div class="control is-expanded">
                    <div class="select is-fullwidth">
                      <select v-model="icon.upper_spacing" @change="upperControl" :disabled="!['', 'N/A'].includes(this.icon.upper_arch_crowding.id)">
                          <option v-for="(upper_spacing_option, upper_spacing_option_index) in upper_spacing_options" v-bind:value="{ id: upper_spacing_option.value, text: upper_spacing_option.text }" :key="'upper_spacing_' + upper_spacing_option_index">{{ upper_spacing_option.text }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <article name="upper_spacing_info" class="message is-info" v-show="this.show_upper_spacing_info">
                  <div class="message-header">
                    <p>Info</p>
                    <button class="delete" aria-label="delete" @click="show_upper_spacing_info = false"></button>
                  </div>
                  <div class="message-body">
                    Upper crowding can't occur at the same time as spacing
                  </div>
                </article>

                <div class="field">
                  <label class="label has-text-left">Cross bite</label>
                  <div class="control is-expanded">
                    <div class="select is-fullwidth">
                      <select v-model="icon.cross_bite">
                          <option v-for="(cross_bite_option, cross_bite_option_index) in cross_bite_options" v-bind:value="{ id: cross_bite_option.value, text: cross_bite_option.text }" :key="'cross_bite_' + cross_bite_option_index">{{ cross_bite_option.text }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="field">
                  <label class="label has-text-left">Incisor open bite (mm)</label>
                  <div class="control is-expanded">
                    <div class="select is-fullwidth">
                      <select v-model="icon.incisor_open_bite">
                          <option v-for="(incisor_open_bite_option, incisor_open_bite_option_index) in incisor_open_bite_options" v-bind:value="{ id: incisor_open_bite_option.value, text: incisor_open_bite_option.text }" :key="'incisor_open_bite_option' + incisor_open_bite_option_index">{{ incisor_open_bite_option.text }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="field">
                  <label class="label has-text-left">Incisor over bite (mm)</label>
                  <div class="control is-expanded">
                    <div class="select is-fullwidth">
                      <select v-model="icon.incisor_over_bite">
                        <option v-for="(incisor_over_bite_option, incisor_over_bite_option_index) in incisor_over_bite_options" v-bind:value="{ id: incisor_over_bite_option.value, text: incisor_over_bite_option.text }" :key="'incisor_over_bite_option_' + incisor_over_bite_option_index">{{ incisor_over_bite_option.text }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="field">
                  <label class="label has-text-left">Buccal segment anteroposterior (left)</label>
                  <div class="control is-expanded">
                    <div class="select is-fullwidth">
                      <select v-model="icon.buccal_left">
                        <option v-for="(buccal_left_option, buccal_left_option_index) in buccal_left_options" v-bind:value="{ id: buccal_left_option.value, text: buccal_left_option.text }" :key="'buccal_left_option_' + buccal_left_option_index">{{ buccal_left_option.text }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="field">
                  <label class="label has-text-left">Buccal segment anteroposterior (right)</label>
                  <div class="control is-expanded">
                    <div class="select is-fullwidth">
                      <select v-model="icon.buccal_right">
                        <option v-for="(buccal_right_option, buccal_right_option_index) in buccal_right_options" v-bind:value="{ id: buccal_right_option.value, text: buccal_right_option.text }" :key="'buccal_right_option_' + buccal_right_option_index">{{ buccal_right_option.text }}</option>
                      </select>
                    </div>
                  </div>
                </div>

            </div>
            <div class="column">
                <table class="table is-fullwidth is-striped is-hoverable" ref="iconScoreTable">
                    <thead>
                        <tr>
                            <th><abbr title="Component">Component</abbr></th>
                            <th><abbr title="Description">Description</abbr></th>
                            <th><abbr title="Score">Score</abbr></th>
                        </tr>
                    </thead>
                    <tfoot>
                        <tr>
                            <th><abbr title="Total score">Total score </abbr></th>
                            <th><a class="button" @click="copy"><span class="icon is-small"><i class="fas fa-copy"></i></span><span>Copy</span></a></th>
                            <th><abbr title="Score"><span class="is-size-1" v-if="allVariablesSet"> {{ calculateIcon }} </span></abbr></th>
                        </tr>
                    </tfoot>
                    <tbody>
                        <tr>
                            <td>Aesthetic</td>
                            <td>{{ this.icon.aesthetic.text }}</td>
                            <td>{{ this.icon.aesthetic.id }}</td>
                        </tr>
                        <tr>
                            <td>Upper arch crowding (mm)</td>
                            <td>{{ this.icon.upper_arch_crowding.text }}</td>
                            <td>{{ this.icon.upper_arch_crowding.id }}</td>
                        </tr>
                        <tr>
                            <td>Upper spacing (mm)</td>
                            <td>{{ this.icon.upper_spacing.text }}</td>
                            <td>{{ this.icon.upper_spacing.id }}</td>
                        </tr>
                        <tr>
                            <td>Cross bite</td>
                            <td>{{ this.icon.cross_bite.text }}</td>
                            <td>{{ this.icon.cross_bite.id }}</td>
                        </tr>
                        <tr>
                            <td>Incisor open bite (mm)</td>
                            <td>{{ this.icon.incisor_open_bite.text }}</td>
                            <td>{{ this.icon.incisor_open_bite.id }}</td>
                        </tr>
                        <tr>
                            <td>Incisor over bite (mm)</td>
                            <td>{{ this.icon.incisor_over_bite.text }}</td>
                            <td>{{ this.icon.incisor_over_bite.id }}</td>
                        </tr>
                        <tr>
                            <td>Buccal segment anteroposterior (left)</td>
                            <td>{{ this.icon.buccal_left.text }}</td>
                            <td>{{ this.icon.buccal_left.id }}</td>
                        </tr>
                        <tr>
                            <td>Buccal segment anteroposterior (right)</td>
                            <td>{{ this.icon.buccal_right.text }}</td>
                            <td>{{ this.icon.buccal_right.id }}</td>
                        </tr>
                    </tbody>
                </table>

                <div class="field" v-show="iconType == 'post-icon'">
                  <label class="label has-text-left">Pre icon score</label>
                  <div class="control is-expanded">
                    <div class="select is-fullwidth">
                      <select v-model="preTreatmentScore">
                        <option v-for="i in (1,128)" :key="i">{{ i }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <table class="table is-fullwidth is-striped is-hoverable" v-if="preTreatmentScore>0 && allVariablesSet">
                    <tfoot>
                        <tr>
                            <th><abbr title="Post treatment ICON score">Post treatment ICON score</abbr></th>
                            <th class="has-text-right"><abbr title="Score"><span class="is-size-1"> {{ calculateImprovementGrade }} </span></abbr></th>
                        </tr>
                    </tfoot>
                </table>

                <table class="table is-fullwidth is-striped is-hoverable" v-show="iconType == 'pre-icon'">
                    <thead>
                        <tr>
                            <th><abbr title="Score">Score</abbr></th>
                            <th><abbr title="Complexity">Complexity</abbr></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr :class="getComplexityTag(7,28)">
                            <td>7 - 28</td>
                            <td>Easy</td>
                        </tr>
                        <tr :class="getComplexityTag(29,50)">
                            <td>29 - 50</td>
                            <td>Mild</td>
                        </tr>
                        <tr :class="getComplexityTag(51,63)">
                            <td>51 - 63</td>
                            <td>Moderate</td>
                        </tr>
                        <tr :class="getComplexityTag(64,77)">
                            <td>64 - 77</td>
                            <td>Difficult</td>
                        </tr>
                        <tr :class="getComplexityTag(78,128)">
                            <td>78 - 128</td>
                            <td>Very difficult</td>
                        </tr>
                    </tbody>
                </table>

                <table class="table is-fullwidth is-striped is-hoverable" v-show="iconType == 'post-icon'">
                    <thead>
                        <tr>
                            <th><abbr title="Score">Score</abbr></th>
                            <th><abbr title="Improvement">Improvement</abbr></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr :class="getImprovementTag(0,999)">
                            <td>>= 0</td>
                            <td>Greatly improved</td>
                        </tr>
                        <tr :class="getImprovementTag(-25,-1)">
                            <td>-1 to -25</td>
                            <td>Substantially improved</td>
                        </tr>
                        <tr :class="getImprovementTag(-53,-26)">
                            <td>-26 to -53</td>
                            <td>Moderately improved</td>
                        </tr>
                        <tr :class="getImprovementTag(-85,-54)">
                            <td>-54 to -85</td>
                            <td>Minimally improved</td>
                        </tr>
                        <tr :class="getImprovementTag(-505,-86)">
                            <td>-86 to -505</td>
                            <td>Not improved or worse</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </section>
</template>

<script>

import AestheticOptions from './AestheticOptions.vue'

export default {
  name: 'icon',
  props: {
    iconType: String
  },
  components: {
      AestheticOptions
  },
  data: function() {
      return {
          icon: {
              aesthetic: {id: '', text: ''},
              upper_arch_crowding: {id: '', text: ''},
              upper_spacing: {id: '', text: ''},
              cross_bite: {id: '', text: ''},
              incisor_open_bite: {id: '', text: ''},
              incisor_over_bite: {id: '', text: ''},
              buccal_left: {id: '', text: ''},
              buccal_right: {id: '', text: ''}
          },
          aesthetic_options: [
              { text: '', value: '', key: 'aesthetic_1' },
              { text: 1, value: 1, key: 'aesthetic_2' },
              { text: 2, value: 2, key: 'aesthetic_3' },
              { text: 3, value: 3, key: 'aesthetic_4' },
              { text: 4, value: 4, key: 'aesthetic_5' },
              { text: 5, value: 5, key: 'aesthetic_6' },
              { text: 6, value: 6, key: 'aesthetic_7' },
              { text: 7, value: 7, key: 'aesthetic_8' },
              { text: 8, value: 8, key: 'aesthetic_9' },
              { text: 9, value: 9, key: 'aesthetic_10' },
              { text: 10, value: 10, key: 'aesthetic_11' }
          ],
          upper_arch_crowding_options: [
            { text: '', value: '' },
            { text: 'x < 2', value: '0' },
            { text: '2.1 < x < 5', value: '1' },
            { text: '5.1 < x < 9', value: '2' },
            { text: '9.1 < 13', value: '3' },
            { text: '< 13.1 < 17', value: '4' },
            { text: '>17 or impacted teeth', value: '5' }
          ],
          upper_spacing_options: [
            { text: '', value: '' },
            { text: 'x < 2', value: '0' },
            { text: '2.1 < x < 5', value: '1' },
            { text: 'x5.1 < x < 9', value: '2' },
            { text: '< 9.1', value: '3' }
          ],
          cross_bite_options: [
            { text: '', value: '' },
            { text: 'No cross bite', value: '0' },
            { text: 'Cross bite present', value: '1' }
          ],
          incisor_open_bite_options: [
            { text: '', value: '' },
            { text: 'Complete bite', value: '0' },
            { text: 'x < 1', value: '1' },
            { text: '1.1 < x < 2', value: '2' },
            { text: '2.1 < 4', value: '3' },
            { text: '< 4', value: '4' }
          ],
          incisor_over_bite_options: [
            { text: '', value: '' },
            { text: 'Up to 1/3 tooth', value: '0' },
            { text: '1/3 to 2/3 coverage', value: '1' },
            { text: '2/3 up to fully covered', value: '2' },
            { text: 'Fully covered', value: '3' }
          ],
          buccal_left_options: [
            { text: '', value: '' },
            { text: 'Cusp to embrace relationship only, Class I, II or III', value: '0' },
            { text: 'Any cusp relation up to but not including cusp to cusp', value: '1' },
            { text: 'Cusp to cusp relationship', value: '2' }
          ],
          buccal_right_options: [
            { text: '', value: '' },
            { text: 'Cusp to embrace relationship only, Class I, II or III', value: '0' },
            { text: 'Any cusp relation up to but not including cusp to cusp', value: '1' },
            { text: 'Cusp to cusp relationship', value: '2' }
          ],
          show_upper_spacing_info: false,
          show_upper_crowding_info: false,
          showAestheticOptionsModal: false,
          preTreatmentScore: 0
      }
  },
  methods: {
      upperControl: function() {
          if(!['', 'N/A'].includes(this.icon.upper_arch_crowding.id) ){
              this.icon.upper_spacing = {id: '', text: 'N/A'}
              this.show_upper_crowding_info = true;
          }
          else {
              this.show_upper_crowding_info = false;
          }
          //console.log(this.icon.upper_spacing);
          if(!['', 'N/A'].includes(this.icon.upper_spacing.id) ){
              this.icon.upper_arch_crowding = {id: '', text: 'N/A'}
              this.show_upper_spacing_info = true;
              //console.log(this.icon.upper_arch_crowding)
          }
          else {
              this.show_upper_spacing_info = false;
          }
      },
      getComplexityTag(from, to){
          var x = this.calculateIcon
          var s = ''
          if(x >= from && x <= to){
              s = 'is-selected'
          }
          return s
      },
      getImprovementTag(from, to){
          var x = this.calculateImprovementGrade
          var s = ''
          if( x >= from && x <= to) {
              s = 'is-selected'
          }
          return s
      },
      copy() {
          var t = 'Aesthetic: ' + this.icon.aesthetic.text + ', score: ' + this.icon.aesthetic.id
          t += '\nUpper arch crowding: ' + this.icon.upper_arch_crowding.text + ', score: ' + this.icon.upper_arch_crowding.id
          t += '\nUpper spacing: ' + this.icon.upper_spacing.text + ', score: ' + this.icon.upper_spacing.id
          t += '\nCross bite: ' + this.icon.cross_bite.text + ', score: ' + this.icon.cross_bite.id
          t += '\nIncisor open bite: ' + this.icon.incisor_open_bite.text + ', score: ' + this.icon.incisor_open_bite.id
          t += '\nIncisor over bite: ' + this.icon.incisor_over_bite.text + ', score: ' + this.icon.incisor_over_bite.id
          t += '\nBuccal left: ' + this.icon.buccal_left.text + ', score: ' + this.icon.buccal_left.id
          t += '\nBuccal right: ' + this.icon.buccal_right.text + ', score: ' + this.icon.buccal_right.id
          t += '\n\nTotal score according to pre ICON: ' + this.calculateIcon
          this.$copyText(t)
      }
  },
  computed: {
      allVariablesSet() {
          if( Object.values(this.icon).every( x => { return x.text == 'N/A' || (parseInt(x.id) >= 0 && !isNaN(x.id) && x.id != '') }) ){
              return true
          }
          else {
              return false
          }
      },
      calculateIcon() {
          var icon = 0

          var upper_arch_crowding = 1;
          var upper_spacing = 1;
          if(!['', 'N/A'].includes(this.icon.upper_arch_crowding.id) ){
              upper_arch_crowding = this.icon.upper_arch_crowding.id
          }
          if(!['', 'N/A'].includes(this.icon.upper_spacing.id) ){
              upper_spacing = this.icon.upper_spacing.id
          }

          icon = parseInt(this.icon.aesthetic.id) * 7 + parseInt(upper_arch_crowding) * parseInt(upper_spacing) * 5 + parseInt(this.icon.cross_bite.id) * 5 + Math.max(parseInt(this.icon.incisor_open_bite.id), parseInt(this.icon.incisor_over_bite.id)) * 4 + (parseInt(this.icon.buccal_left.id) + parseInt(this.icon.buccal_right.id)) * 3

          return icon
      },
      calculateImprovementGrade() {
          return this.preTreatmentScore - 4 * this.calculateIcon
      },
      getIndexForClipboard() {
          var text = 'Aesthetic: ' + this.icon.aesthetic.text

          return text
      }
  },
  mounted() {
  }
}
</script>
